// 获取随机颜色
import {Ref} from "vue";
import {CurrentUtils} from "xmgoing-server";
import GoingUtils from "@/utils/goingUtils";

// 深拷贝对象
export function deepClone(obj:any) {
  const _toString = Object.prototype.toString;

  // null, undefined, non-object, function
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  // DOM Node
  if (obj.nodeType && 'cloneNode' in obj) {
    return obj.cloneNode(true)
  }

  // Date
  if (_toString.call(obj) === '[object Date]') {
    return new Date(obj.getTime())
  }

  // RegExp
  if (_toString.call(obj) === '[object RegExp]') {
    const flags:string[] = [];
    if (obj.global) { flags.push('g') }
    if (obj.multiline) { flags.push('m') }
    if (obj.ignoreCase) { flags.push('i') }

    return new RegExp(obj.source, flags.join(''))
  }

  const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {};

  for (const key in obj) {
    result[key] = deepClone(obj[key])
  }

  return result
}


/**
 * 判断是否已经选择了相应记录
 * @param itemRecord
 * @param alreadySelUsers
 */
export const hasSelRecord=function (itemRecord,alreadySelUsers){
  const selRecord=unref(alreadySelUsers).filter((itemRecordDb)=>{
    return itemRecord.id===itemRecordDb.id;
  })
  if(selRecord&&selRecord[0]){
    return selRecord[0];
  }
}

/**
 * 加载用户数据后
 * @param res
 * @param alreadySelUsers
 * @param searchUserList
 */
export function afterLoadUser(res,alreadySelUsers,searchUserList){
  res.records.forEach((itemRecord) => {
    const selRecod=hasSelRecord(itemRecord,alreadySelUsers);
    if(selRecod){
      itemRecord.check = true;
      unref(searchUserList).push(selRecod);
    }else{
      itemRecord.check = false;
      unref(searchUserList).push(itemRecord);
    }
  })
}

export function initSelValuesItem(selValues,itemDb){
  selValues.value.push({
    "label": itemDb.realName||itemDb.name,
    "value": itemDb.id,
    "key": itemDb.id,
    "option": {
      "label": itemDb.realName,
      "value": itemDb.id,
      "remark": `${itemDb.departName}--${itemDb.roleName}`
    },
    "originLabel": itemDb.realName
  })
}
